export type AlignType = 'default' | 'top' | 'middle' | 'baseline' | 'bottom';

export const ALIGN_CLASSES = (elem: string): Record<AlignType, string | null> => ({
    default: null,
    top: `${elem}_v-align-top`,
    middle: `${elem}_v-align-middle`,
    baseline: `${elem}_v-align-baseline`,
    bottom: `${elem}_v-align-bottom`,
});

export type TextAlignType = 'left' | 'center' | 'right';

export const TEXT_ALIGN_CLASSES: Record<TextAlignType, string | null> = {
    left: null,
    center: 'table__col_center',
    right: 'table__col_right',
};

/**
 * @deprecated Use the `textAlign` prop with plain strings instead. It will be removed in 6 months 03-03-2026.
 */
export const TextAlign = {
    LEFT: 'TextAlign.LEFT',
    CENTER: 'TextAlign.CENTER',
    RIGHT: 'TextAlign.RIGHT',
} as const;

/**
 * @deprecated Use `TextAlignType` instead. It will be removed in 6 months 03-03-2026.
 */
export type TextAlignLegacyType = (typeof TextAlign)[keyof typeof TextAlign];

// eslint-disable-next-line @typescript-eslint/no-deprecated
const TEXT_ALIGN_LEGACY_MAP: Record<TextAlignLegacyType, TextAlignType> = {
    // eslint-disable-next-line @typescript-eslint/no-deprecated
    [TextAlign.LEFT]: 'left',
    // eslint-disable-next-line @typescript-eslint/no-deprecated
    [TextAlign.CENTER]: 'center',
    // eslint-disable-next-line @typescript-eslint/no-deprecated
    [TextAlign.RIGHT]: 'right',
};

export const resolveTextAlign = (
    textAlign?: TextAlignType,
    align?: string,
): TextAlignType | undefined => {
    if (textAlign !== undefined) {
        return textAlign;
    }
    if (align !== undefined) {
        // eslint-disable-next-line @typescript-eslint/no-deprecated
        return TEXT_ALIGN_LEGACY_MAP[align as TextAlignLegacyType] ?? (align as TextAlignType);
    }
    return undefined;
};

const ALIGN_VALUES: ReadonlyArray<string> = ['default', 'top', 'middle', 'baseline', 'bottom'];

export const resolveCellVerticalAlign = (
    // eslint-disable-next-line @typescript-eslint/no-deprecated
    verticalAlign?: AlignType | VerticalAlignType,
): AlignType => {
    if (!verticalAlign) {
        return 'default';
    }
    if (ALIGN_VALUES.includes(verticalAlign)) {
        return verticalAlign as AlignType;
    }
    // eslint-disable-next-line @typescript-eslint/no-deprecated
    return VERTICAL_ALIGN_TO_ALIGN[verticalAlign as VerticalAlignType] ?? 'default';
};

/**
 * @deprecated Use the `align` prop with plain strings instead. It will be removed in 6 months 03-03-2026.
 */
export const VerticalAlign = {
    DEFAULT: 'VerticalAlign.DEFAULT',
    TOP: 'VerticalAlign.TOP',
    MIDDLE: 'VerticalAlign.MIDDLE',
    BASELINE: 'VerticalAlign.BASELINE',
    BOTTOM: 'VerticalAlign.BOTTOM',
} as const;

/**
 * @deprecated Use `AlignType` instead. It will be removed in 6 months 03-03-2026.
 */
export type VerticalAlignType = (typeof VerticalAlign)[keyof typeof VerticalAlign];

// eslint-disable-next-line @typescript-eslint/no-deprecated
const VERTICAL_ALIGN_TO_ALIGN: Record<VerticalAlignType, AlignType> = {
    // eslint-disable-next-line @typescript-eslint/no-deprecated
    [VerticalAlign.DEFAULT]: 'default',
    // eslint-disable-next-line @typescript-eslint/no-deprecated
    [VerticalAlign.TOP]: 'top',
    // eslint-disable-next-line @typescript-eslint/no-deprecated
    [VerticalAlign.MIDDLE]: 'middle',
    // eslint-disable-next-line @typescript-eslint/no-deprecated
    [VerticalAlign.BASELINE]: 'baseline',
    // eslint-disable-next-line @typescript-eslint/no-deprecated
    [VerticalAlign.BOTTOM]: 'bottom',
};

export const resolveAlign = (
    align?: AlignType,
    // eslint-disable-next-line @typescript-eslint/no-deprecated
    verticalAlign?: VerticalAlignType,
): AlignType => {
    if (align !== undefined) {
        return align;
    }
    if (verticalAlign !== undefined) {
        return VERTICAL_ALIGN_TO_ALIGN[verticalAlign];
    }
    return 'default';
};
